import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'
import './HomeNavigation.css'
import HomeHeader from './HomeHeader'
//import Footer from '../UIElements/Footer'
import HomeNavLinks from './HomeNavLinks'
import SideDrawer from '../../../admin/components/SideDrawer'
import Backdrop from '../UIElements/Backdrop'
import standingsLogo from '../../../images/statsAndStanings_transparent.png'
import playerStatsLogo from '../../../images/playerPages_transparent.png'
import adminLogo from '../../../images/adminLogin_transparent.png'

const StatsAndStandingsHomeNavigation = (props) => {
	const [drawerIsOpen, setDrawerIsOpen] = useState(false)

	const location = useLocation()

	// true ONLY when URL ends with /history
	const showSearchForPlayer = location.pathname.endsWith('/history')
	const admin = location.pathname.endsWith('/login')

	const openDrawerHandler = () => {
		setDrawerIsOpen(true)
	}

	const closeDrawerHandler = () => {
		setDrawerIsOpen(false)
	}

	return (
		<React.Fragment>
			{drawerIsOpen && <Backdrop onClick={closeDrawerHandler} />}
			<SideDrawer show={drawerIsOpen} onClick={closeDrawerHandler}>
				<nav className='home-navigation__drawer-nav'>
					<HomeNavLinks leagueId={props.leagueId} />
				</nav>
			</SideDrawer>
			<HomeHeader>
				<button
					className='home-navigation__menu-btn'
					onClick={openDrawerHandler}
				>
					<span />
					<span />
					<span />
				</button>
				{showSearchForPlayer && (
					<div className='headerWidth'>
						<img src={playerStatsLogo} className='playerStatsLogo' />
					</div>
				)}
				{admin && (
					<div className='headerWidth'>
						<img src={adminLogo} className='adminLogo' />
					</div>
				)}
				{!showSearchForPlayer && !admin && (
					<div className='headerWidth'>
						<img src={standingsLogo} className='scheduleHeaderLogo' />
					</div>
				)}
				<nav className='home-navigation__header-nav'>
					<HomeNavLinks leagueId={props.leagueId} />
				</nav>
			</HomeHeader>
		</React.Fragment>
	)
}

export default StatsAndStandingsHomeNavigation
